module.exports = __webpack_public_path__ + "img/cars.5efaf0b2.webp";